export const tab = () => {
  // selectors
  const allSelectors = document.querySelectorAll(".js-tab-selector");
  const allSelectorsArr = Array.prototype.slice.call(allSelectors);

  // tabs
  const allTabs = document.querySelectorAll(".js-tab");
  const allTabsArr = Array.prototype.slice.call(allTabs);

  // when selector is clicked
  allSelectorsArr.forEach((selector, index) => {
    selector.addEventListener("click", () => {
      const targetTab = document.getElementById(`tab-${index + 1}`);
      removeAllActiveClass();
      selector.classList.add("is-active");
      targetTab.classList.add("is-active");
    });
  });

  // remove 'is-active' class
  function removeAllActiveClass() {
    allSelectorsArr.forEach((selector) => {
      selector.classList.remove("is-active");
    });

    allTabsArr.forEach((tab) => {
      tab.classList.remove("is-active");
    });
  }
};
